import { mapState, mapActions } from 'vuex'

export default {
  data() {
    return {
      
    }
  },
  computed: {
    ...mapState({
      languages: state => state.languages.languages,
      currentLanguage: state => state.uiLanguages.currentLanguage,
      currentLanguageId: state => state.uiLanguages.currentLanguageId
    })
  },
  methods: {
    ...mapActions([
      'getLanguages'
    ]),
    fetchLanguages() {
      this.getLanguages({
        params: {
          idLanguage: localStorage.ui_language_id,
          order: "languageNames"
        }
      })
    }
  },
  watch: {
    currentLanguage() {
      this.fetchLanguages()
    }
  }
}
